import React from 'react';

import styled from 'styled-components';

interface YoutubeEmbedProps {
    embedId: string;
}

const YoutubeEmbed: React.FC<React.PropsWithChildren<YoutubeEmbedProps>> = ({
    embedId,
}) => {
    return (
        <ResponsiveWrapper>
            <iframe
                src={`https://www.youtube.com/embed/${embedId}?autoplay=1&mute=1`}
                frameBorder="0"
                allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                width="853"
                height="459"
                title={embedId}
            />
        </ResponsiveWrapper>
    );
};

export default YoutubeEmbed;

const ResponsiveWrapper = styled.div({
    overflow: 'hidden',
    paddingBottom: '56.25%',
    position: 'relative',
    height: 0,
});
